/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { I18n } from 'react-redux-i18n';

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        left: '-40px',
        zIndex: 1,
        fontSize: '30px',
        color: 'black',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      ❮
    </div>
  );
}

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        right: '-40px',
        zIndex: 1,
        fontSize: '30px',
        color: 'black',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      ❯
    </div>
  );
}

function ImageCarousel({ images = [], width = '60vw', height = '60vh' }) {
  if (!Array.isArray(images) || images.length === 0) {
    return (
      <p style={{ textAlign: 'center', color: '#666', fontSize: '16px' }}>
        {I18n.t('BEE4333' /* Nenhuma imagem disponível. */)}
      </p>
    );
  }

  const [selectedIndex, setSelectedIndex] = useState(0);
  const sliderRef = React.useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    beforeChange: (current, next) => setSelectedIndex(next),
  };

  return (
    <div
      className="image-carousel"
      style={{
        position: 'relative',
        width,
        height,
        margin: 'auto',
      }}
    >
      {images ? (
        images.length > 1 ? (
          <>
            <Slider ref={sliderRef} {...settings}>
              {images.map((image, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <img
                    src={image.url}
                    alt={image.description}
                    style={{
                      width,
                      height,
                      objectFit: 'contain',
                      borderRadius: '10px',
                    }}
                  />
                  <div
                    style={{
                      marginTop: '10px',
                      fontSize: '18px',
                      fontWeight: 'bold',
                      color: '#333',
                      width: '100%',
                      textAlign: 'center',
                      whiteSpace: 'normal',
                      padding: '0 20px',
                    }}
                  >
                    <div style={{ fontSize: '12px' }}>
                      {image.description || I18n.t('BEE4328' /* Sem descrição. */)}
                      <br />
                      {I18n.t('BEE4327' /* Tags */)}:
                      {image.tags && image.tags.length > 0
                        ? image.tags.map((tag) => ` #${tag}`).join('')
                        : ` ${I18n.t('BEE9999' /* Sem tags. */)}`}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '10px',
                marginBottom: '10px',
                gap: '10px',
                paddingBottom: '10px',
                flexWrap: 'wrap',
              }}
            >
              {images.map((image, index) => (
                <img
                  key={index}
                  src={image.url}
                  alt={image.description}
                  onClick={() => {
                    setSelectedIndex(index);
                    sliderRef.current?.slickGoTo(index);
                  }}
                  style={{
                    width: '50px',
                    height: '50px',
                    objectFit: 'cover',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    border: selectedIndex === index ? '2px solid black' : '2px solid transparent',
                  }}
                />
              ))}
            </div>
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <img
              src={images[0].url}
              alt={images[0].description || I18n.t('BEE4328' /* Sem descrição. */)}
              style={{
                width: '80%',
                height: '80%',
                objectFit: 'contain',
                borderRadius: '10px',
              }}
            />
            <div
              style={{
                marginTop: '10px',
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#333',
                width: '100%',
                textAlign: 'center',
                whiteSpace: 'normal',
                padding: '0 20px',
              }}
            >
              <div style={{ fontSize: '12px' }}>
                {images[0].description || I18n.t('BEE4328' /* Sem descrição. */)}
                <br />
                {I18n.t('BEE4327' /* Tags */)}:
                {images[0].tags && images[0].tags.length > 0
                  ? images[0].tags.map((tag) => ` #${tag}`).join('')
                  : ` ${I18n.t('BEE9999' /* Sem tags. */)}`}
              </div>
            </div>
          </div>
        )
      ) : (
        <p style={{ textAlign: 'center', color: '#666', fontSize: '16px' }}>
          {I18n.t('BEE5000' /* Nenhuma imagem disponível. */)}
        </p>
      )}

      
    </div>
  );
}

export default ImageCarousel;
